module.exports = __webpack_public_path__ + "img/PROPERTYTAXRECEIPT.095eb2b4.png";